import styled from '@emotion/styled';
import { CloseIcon } from 'src/domains/layouts/shared/assets/icons/CloseIcon';
import { ExclamationMarkIcon } from 'src/domains/layouts/shared/assets/icons/ErrorExclamationMark';
import { WarningIcon } from 'src/domains/layouts/shared/assets/icons/WarningIcon';
import { PageSectionWrapper } from 'src/domains/players/webview/components/SignUp/signupParts/Signup.style';
import { withConfig } from 'src/withConfig';

export const VerificationFailedWrapper = styled(PageSectionWrapper, { label: 'VerificationFailedWrapper' })`
    text-align: center;
`;

export const CloseWrapper = styled('div', { label: 'CloseWrapper' })`
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const CloseTitle = withConfig(theme => styled('div', { label: 'CloseTitle' })`
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.5;
`);

export const WarningTriangleIconWrapper = styled(WarningIcon, { label: 'WarningTriangleIconWrapper' })`
    position: absolute;
    top: 22px;
    right: 24px;
    width: 32px;
    fill: currentcolor;
`;

export const HeaderCloseIcon = styled(CloseIcon, { label: 'HeaderCloseIcon' })`
    cursor: pointer;
    fill: currentcolor;
    margin-left: auto;
    padding: 2px;
    width: 20px;
`;


export const WarningIconWrapper = styled(ExclamationMarkIcon, { label: 'WarningIconWrapper' })`
    position: absolute;
    top: 17px;
    right: 16px;
    width: 32px;
    fill: currentcolor;
`;

export const WarningIconContainer = withConfig(theme => styled('div', { label: 'WarningIconContainer' })`
    position: relative;
    margin: 32px auto 24px;
    width: 64px;
    height: 64px;
    background-color: ${theme.star.signUp.bgColorSecondary};
    border-radius: 50px;
`);

export const WarningTriangle = withConfig(theme => styled('div', { label: 'WarningTriangle' })`
    position: relative;
    margin: 160px auto 24px;
    width: 80px;
    height: 80px;
    background-color: ${theme.star.signUp.bgColorSecondary};
    border-radius: 50px;
`);

export const WarningTriangleGamStop = styled(WarningTriangle, { label: 'WarningTriangleGamStop' })`
    margin: 196px auto 16px;
`;

export const EmailLink = withConfig(theme => styled('a', { label: 'EmailLink' })`
    color: ${theme.star.signUp.txtColorSecondary};
    font-weight: ${theme.star.fontWeight.bold};
    text-decoration: none;
`);

export const EmailLinkNew = withConfig(theme => styled('a', { label: 'EmailLinkNew' })`
    color: ${theme.star.signUp.txtColorTertiary};
    text-decoration: none;
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.43 !important;
`);

export const HighlightedTxt = withConfig(theme => styled('span', { label: 'HighlightedTxt' })`
    color: ${theme.star.signUp.txtColorSecondary};
    font-weight: ${theme.star.fontWeight.bold};
`);

